module.exports = __webpack_public_path__ + "img/icon_pup_tips@3x.6adfb785.png";